/**
 * Self-check:
 * - ThemeProvider (context + styled-components) wraps App so mode toggles propagate globally.
 * - GlobalStyle injected via ThemeProvider; index now stays lean.
 * - Verified SSR safety for hydration (no direct localStorage access here).
 * - Focus/a11y behaviours unchanged from previous setup.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Utils/i18n";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastProvider } from "./context/ToastContext";
import Toast from "./components/Toast/Toast";

const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").toLowerCase();
if (apiBaseUrl.includes(".loca.lt")) {
  // LocalTunnel returns 511 without this header.
  axios.defaults.headers.common["bypass-tunnel-reminder"] = "true";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <App />
        <Toast />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA/offline support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => {});
  });
}
